import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeMsal } from './features/authentication';
import './index.css';

// MSAL must be initialized before the app renders so that
// handleRedirectPromise() can process the auth code from the URL hash.
initializeMsal().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
